/** @jsxImportSource @emotion/react */

import { useContext, useRef, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";

import RebatesClient from "../../RebatesClient";

import logo from "../../components/logo/valley-logo.png";
import FormikTextField from "../../components/form/formik-text-field/formik-text-field";
import { CustomButton, Icon } from "../../components";

import css from "./login.module.css";

function ResetPassword(props) {
	const navigate = useNavigate();

	const [searchParams, setSearchParams] = useSearchParams();

	let uid = searchParams.get("userId");
	let token = searchParams.get("token");

	const initialValues = {
		confirmPassword: "",
		password: "",
		userId: uid,
		token,
	};

	const toastRef = useRef();
	const [hasError, setHasError] = useState(false);

	const { mutateAsync: onSubmit, isLoading } = useMutation({
		mutationKey: "reset_password",
		mutationFn: async (data) => {
			const response = RebatesClient.resetPassword(data);
			return response;
		},
		onSuccess: (data) => {
			alert("Congratulations, your password has been changed!");
			navigate("/login");
		},
		onError: (error) => {
			toastRef.current.show({
				severity: "error",
				summary: "Error",
				detail: error.toString(),
				life: 13000,
			});
			setHasError(true);
		},
	});

	return (
    <main className={css.main}>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={Yup.object({
          password: Yup.string().label("Password").min(6).required(),
          confirmPassword: Yup.string()
            .label("Confirm Password")
            .oneOf([Yup.ref("password"), null], "Passwords must match"),
        })}
      >
        {(formik) => (
          <Form className={css.form}>
            <Icon icon="ValleyLogo" />

            <div className={css.fieldset}>
              <div className={css.intro}>
                <div className={css.title}>Password reset</div>
                <div className={css.subtitle}>Enter a new password below.</div>
              </div>

              <div className={css.fields}>
                <FormikTextField
                  label="Password"
                  labelShrink={true}
                  name="password"
                  type="password"
                  // value={formik.values.password}
                />

                <FormikTextField
                  label="Confirm Password"
                  labelShrink={true}
                  name="confirmPassword"
                  type="password"
                  // value={formik.values.confirm_password}
                />

                <CustomButton
                  type="submit"
                  label="Submit"
                  disabled={
                    isLoading ||
                    Object.values(formik.errors).length ||
                    hasError
                  }
                  isFullWidth
                  style={{
                    marginTop: 20,
                    width: "100%"
                  }}
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </main>
	);
}

export default ResetPassword;
